/*
 * @Description: file content
 * @Author: wangalong
 * @Date: 2022-04-15 18:06:02
 * @LastEditTime: 2022-05-25 18:23:49
 */
import request from './request';

export function getSignPackage() {
    return request({
        url: '/Wx/getSignPackage',
        method: 'post',
        params: {
            url: window.location.href.split('#')[0],
            kbSecretKey: "COVID-19"
        }
    })
}